<template>
    <div class="home">
        <DateAccommodationCheck></DateAccommodationCheck>
        <!-- 
        <h2>{{ $t("booking notes") }}</h2>
        <p>{{ $t("Holidays start and end on a Monday, except the Early & Late Sumer Specials and September weeks when extra days may be added. See website for details. Please phone us on 01825 748318 to book Houseparty individual rates which cannot be booked online.") }}</p>
         -->

        <h2>{{ $t("welcome booking title") }}</h2>
        <p style="margin-bottom:0.7rem">{{ $t("welcome booking paragraph_1") }}</p>
        <p style="margin-bottom:0.7rem">{{ $t("welcome booking paragraph_2") }}</p>
        <p style="margin-bottom:0.7rem">{{ $t("welcome booking paragraph_3") }}</p>
        <p style="margin-bottom:0.7rem">{{ $t("welcome booking paragraph_4") }} <a href="mailto:info@springharvestholidays.com">info@springharvestholidays.com</a>.</p>

    </div>
</template>

<script>
// @ is an alias to /src
import DateAccommodationCheck from "@/components/DateAccommodationCheck.vue";
import { mapGetters } from 'vuex';

export default {
    name: "Home",
    components: {
        DateAccommodationCheck
    },
    mounted () {
        
        // console.log('bookingCurToInject',bookingCurToInject);
        if(bookingCurToInject=='EUR') {
            this.$store.commit('UPDATE_CURRENCY','EUR');
            this.getCurrency.popupShown=true;
        } else if(bookingCurToInject=='GBP') {
            this.$store.commit('UPDATE_CURRENCY','GBP');
            this.getCurrency.popupShown=true;            
        } else if(!this.getCurrency.popupShown&&bookingCurToInject=='') {
            this.$swal({
                title: '',
                text: this.$t("You are about to make your booking in pounds sterling (£). If you will be paying in euros (€), please choose the appropriate option."),
                showCancelButton: true,
                confirmButtonText: this.$t("Switch to euros (€)"),
                confirmButtonColor: '#00b8d3',
                cancelButtonText: this.$t("Continue in pounds sterling (£)"),
                cancelButtonColor: '#00b8d3',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store.commit('UPDATE_CURRENCY','EUR');
                } else {
                    this.$store.commit('UPDATE_CURRENCY','GBP');
                }
            })
        };
    },
    created () {

    },
    computed: {
        ...mapGetters([
            'getCurrency',
        ]),        
    },
};
</script>
